import React from "react";
import YoungMan from "./assets/youngman.png";
import styles from "./ContactBody.module.scss";
import { motion } from "framer-motion";
const { cBody, header, content } = styles;
const ContactBody = () => {
  return (
    <div className={`${cBody} global-lr-pad`}>
      <motion.div
        className={header}
        initial={{
          y: "10rem",
          opacity: 0,
        }}
        whileInView={{
          y: 0,
          opacity: 1,
          transition: {
            duration: 0.6,
            type: "tween",
            delay: 0.2,
          },
        }}
      >
        <h2>SHOP - PAY -SAVE</h2>
        <h1>Contact Us</h1>
        <p>
          Here we are, a revolutionized people helping you do business the new,
          digital way. Shoot us a message if you ever feel lost in the middle of
          a transaction, need help, don't know where to begin, or you just want
          to talk to someone. We are always around the corner if you need us
        </p>
      </motion.div>
      <div className={content}>
        <div>
          <img
            src={YoungMan}
            alt="A young man with a phone using the we quick pay app"
          />
        </div>
        <motion.form
          initial={{
            x: "7rem",
            opacity: 0.5,
          }}
          animate={{
            x: 0,
            opacity: 1,
            transition: {
              duration : .5,
              delay: 0.3,
            },
          }}
        >
          <h1>Get In touch</h1>
          <input type={"text"} placeholder="Your Email Address" />
          <input type={"text"} placeholder="Subject" />
          <textarea placeholder="Message" />
          <button type="submit">Send</button>
        </motion.form>
      </div>
    </div>
  );
};

export default ContactBody;
